import { createAction, props } from '@ngrx/store';
import { APIResponse } from 'src/app/core/models/api-response';
import {
  ICreateWorkflowRuleDTO,
  IUpdateWorkflowRuleDTO,
  IWorkflowRule,
  IWorkflowRuleSummary,
  IWorkflowSchema,
  IWorkflowTemplate,
  WorkflowRuleStatus,
} from '../models/workflows.models';

// ─── Load rules ─────────────────────────────────────────────────────────────

export const GetWorkflowRules = createAction('[ Workflows ] GetWorkflowRules');

export const GetWorkflowRulesSuccess = createAction(
  '[ Workflows ] GetWorkflowRules Success',
  props<{ response: APIResponse<IWorkflowRuleSummary> }>()
);

export const GetWorkflowRulesError = createAction('[ Workflows ] GetWorkflowRules Error');

export const SetWorkflowsLoader = createAction(
  '[ Workflows ] SetWorkflowsLoader',
  props<{ isLoading: boolean }>()
);

// ─── Schema ─────────────────────────────────────────────────────────────────

export const GetWorkflowSchema = createAction('[ Workflows ] GetWorkflowSchema');

export const GetWorkflowSchemaSuccess = createAction(
  '[ Workflows ] GetWorkflowSchema Success',
  props<{ schema: IWorkflowSchema }>()
);

export const GetWorkflowSchemaError = createAction('[ Workflows ] GetWorkflowSchema Error');

// ─── Templates ──────────────────────────────────────────────────────────────

export const GetWorkflowTemplates = createAction('[ Workflows ] GetWorkflowTemplates');

export const GetWorkflowTemplatesSuccess = createAction(
  '[ Workflows ] GetWorkflowTemplates Success',
  props<{ templates: IWorkflowTemplate[] }>()
);

export const GetWorkflowTemplatesError = createAction('[ Workflows ] GetWorkflowTemplates Error');

// ─── Delete rule ────────────────────────────────────────────────────────────

export const DeleteWorkflowRule = createAction(
  '[ Workflows ] DeleteWorkflowRule',
  props<{ id: string }>()
);

export const DeleteWorkflowRuleSuccess = createAction(
  '[ Workflows ] DeleteWorkflowRule Success',
  props<{ id: string }>()
);

export const DeleteWorkflowRuleError = createAction('[ Workflows ] DeleteWorkflowRule Error');

// ─── Toggle status ──────────────────────────────────────────────────────────

export const ToggleWorkflowRuleStatus = createAction(
  '[ Workflows ] ToggleWorkflowRuleStatus',
  props<{ id: string; status: WorkflowRuleStatus }>()
);

export const ToggleWorkflowRuleStatusSuccess = createAction(
  '[ Workflows ] ToggleWorkflowRuleStatus Success',
  props<{ id: string; status: WorkflowRuleStatus }>()
);

export const ToggleWorkflowRuleStatusError = createAction(
  '[ Workflows ] ToggleWorkflowRuleStatus Error'
);

// ─── Save rule (create/update) ───────────────────────────────────────────────

export const SaveWorkflowRule = createAction(
  '[ Workflows ] SaveWorkflowRule',
  props<{
    id?: string;
    dto: ICreateWorkflowRuleDTO | IUpdateWorkflowRuleDTO;
    targetStatus: WorkflowRuleStatus;
  }>()
);

export const SaveWorkflowRuleSuccess = createAction(
  '[ Workflows ] SaveWorkflowRule Success',
  props<{ rule: IWorkflowRule; completedAt: number }>()
);

export const SaveWorkflowRuleError = createAction('[ Workflows ] SaveWorkflowRule Error');

export const ResetWorkflowSaveState = createAction('[ Workflows ] ResetWorkflowSaveState');
